// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BiTsNxnj6nrd9bDgC6lA {
  height: 100vh;
  width: 100vw;
  display: block;
  padding: 12px;
  position: relative;
}

.CgXUX7NDujQShZMK5vcp {
  height: calc(100vh - 24px);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--surface-bg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.C4aDRQQUDNDPkGLjlSlQ {
  position: relative;
  text-align: center;
  padding: 12px 16px 12px;
  border-bottom: 1px solid var(--border-color);
  background: var(--surface-bg-2);
  flex-shrink: 0;
}

.w_MEFWG8BBFST5LPqcxa {
  letter-spacing: 0.28em;
  font-size: 11px;
  color: var(--accent-color);
  margin-bottom: 6px;
}

.CVDpMafseO9CpCz5hONg {
  margin: 0;
  font-size: 20px;
  color: var(--text-color);
  font-weight: 600;
  padding: 0 160px;
}

.y61vn5SfFjnkb6W3dbHm {
  margin-top: 5px;
  margin-bottom: 0;
  color: var(--text-muted);
  font-size: 12px;
}

/* ── Industry bar: tabs + new-session button on one row ── */
.iFyA4jcD63p09vj0nGM6 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 0 0;
  flex-wrap: wrap;
}

.tn69s3Xq7HuLYpYdLVx4 {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
}

.OoNymXT1YZ0bPv9uDsEg {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 14px;
  border-radius: 20px;
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--text-muted);
  font-size: 12px;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
  white-space: nowrap;
}

.OoNymXT1YZ0bPv9uDsEg:hover {
  border-color: var(--accent-color);
  color: var(--text-color);
}

.wp54zMMFLtl1UnGz4xQJ {
  border-color: var(--accent-color);
  background: rgba(167, 121, 255, 0.12);
  color: var(--accent-color);
  font-weight: 500;
}

.JXFJGVwXBSRu5vvFI18l {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.7;
  flex-shrink: 0;
}

/* 新对话按钮 */
.pNZJP4sbuDev9pLViSYU {
  padding: 5px 12px;
  border-radius: 20px;
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--text-muted);
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.15s, color 0.15s;
}

.pNZJP4sbuDev9pLViSYU:hover {
  border-color: var(--accent-color);
  color: var(--accent-color);
}

/* ── Chat area ── */
.yDAcrIfAnAuKPhhtNe0v {
  min-height: 0;
  flex: 1;
}

/* ── Admin menu (fixed top-right) ── */
.f3WsfdlDkqKgcu9KWhAz {
  position: fixed;
  right: 12px;
  top: 12px;
  z-index: 30;
}

.ARhJ81vxWhIrCb2FJ3W8 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  background: var(--surface-bg-2);
  color: var(--accent-color);
  font-size: 12px;
  letter-spacing: 0.04em;
}

.EYWZmKlYHbe8lZm99BcR {
  width: 14px;
  height: 14px;
  display: inline-flex;
}

.EYWZmKlYHbe8lZm99BcR svg {
  width: 14px;
  height: 14px;
  fill: currentColor;
}

.Mqp7Ne5y56LGN3oR8A1Q {
  color: var(--text-muted);
  font-size: 10px;
}

.ARhJ81vxWhIrCb2FJ3W8:hover {
  border-color: var(--accent-color);
  color: #ffffff;
}

.HuEvIUwGvfdtgQ9ylSvG {
  position: fixed;
  right: 12px;
  top: 44px;
  min-width: 140px;
  padding: 4px;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  background: var(--surface-bg-2);
  z-index: 31;
}

.sHej7ppz0nJrKfRynUHX {
  display: block;
  padding: 7px 8px;
  border-radius: 4px;
  color: var(--text-color);
  font-size: 12px;
}

.sHej7ppz0nJrKfRynUHX:hover {
  background: var(--surface-bg);
  color: var(--accent-color);
}

/* ── Mobile ── */
@media (max-width: 768px) {
  .BiTsNxnj6nrd9bDgC6lA { padding: 8px; }
  .CgXUX7NDujQShZMK5vcp { height: calc(100vh - 16px); }
  .C4aDRQQUDNDPkGLjlSlQ { padding: 10px 12px 10px; }
  .CVDpMafseO9CpCz5hONg { font-size: 16px; padding: 0 90px 0 0; text-align: left; }
  .y61vn5SfFjnkb6W3dbHm { text-align: left; font-size: 11px; }
  .iFyA4jcD63p09vj0nGM6 { justify-content: flex-start; padding-top: 8px; }
  .OoNymXT1YZ0bPv9uDsEg { padding: 4px 10px; font-size: 11px; }
  .pNZJP4sbuDev9pLViSYU { padding: 4px 10px; font-size: 11px; }
  .f3WsfdlDkqKgcu9KWhAz { right: 8px; top: 8px; }
  .ARhJ81vxWhIrCb2FJ3W8 { padding: 5px 8px; font-size: 11px; }
  .HuEvIUwGvfdtgQ9ylSvG { right: 8px; top: 38px; }
}
`, "",{"version":3,"sources":["webpack://./components/HomeChatPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,4CAA4C;EAC5C,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,OAAO;AACT;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,wBAAQ,YAAY,EAAE;EACtB,wBAAe,0BAA0B,EAAE;EAC3C,wBAAa,uBAAuB,EAAE;EACtC,wBAAS,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;EACjE,wBAAS,gBAAgB,EAAE,eAAe,EAAE;EAC5C,wBAAe,2BAA2B,EAAE,gBAAgB,EAAE;EAC9D,wBAAe,iBAAiB,EAAE,eAAe,EAAE;EACnD,wBAAiB,iBAAiB,EAAE,eAAe,EAAE;EACrD,wBAAa,UAAU,EAAE,QAAQ,EAAE;EACnC,wBAAY,gBAAgB,EAAE,eAAe,EAAE;EAC/C,wBAAY,UAAU,EAAE,SAAS,EAAE;AACrC","sourcesContent":[".page {\n  height: 100vh;\n  width: 100vw;\n  display: block;\n  padding: 12px;\n  position: relative;\n}\n\n.centerPanel {\n  height: calc(100vh - 24px);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--surface-bg);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.titleWrap {\n  position: relative;\n  text-align: center;\n  padding: 12px 16px 12px;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--surface-bg-2);\n  flex-shrink: 0;\n}\n\n.subtitle {\n  letter-spacing: 0.28em;\n  font-size: 11px;\n  color: var(--accent-color);\n  margin-bottom: 6px;\n}\n\n.title {\n  margin: 0;\n  font-size: 20px;\n  color: var(--text-color);\n  font-weight: 600;\n  padding: 0 160px;\n}\n\n.motto {\n  margin-top: 5px;\n  margin-bottom: 0;\n  color: var(--text-muted);\n  font-size: 12px;\n}\n\n/* ── Industry bar: tabs + new-session button on one row ── */\n.industryBar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 0 0;\n  flex-wrap: wrap;\n}\n\n.industryTabs {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.industryTab {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 14px;\n  border-radius: 20px;\n  border: 1px solid var(--border-color);\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 12px;\n  cursor: pointer;\n  transition: border-color 0.15s, color 0.15s, background 0.15s;\n  white-space: nowrap;\n}\n\n.industryTab:hover {\n  border-color: var(--accent-color);\n  color: var(--text-color);\n}\n\n.industryTabActive {\n  border-color: var(--accent-color);\n  background: rgba(167, 121, 255, 0.12);\n  color: var(--accent-color);\n  font-weight: 500;\n}\n\n.industryTabDot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: currentColor;\n  opacity: 0.7;\n  flex-shrink: 0;\n}\n\n/* 新对话按钮 */\n.newSessionBtn {\n  padding: 5px 12px;\n  border-radius: 20px;\n  border: 1px solid var(--border-color);\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 12px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: border-color 0.15s, color 0.15s;\n}\n\n.newSessionBtn:hover {\n  border-color: var(--accent-color);\n  color: var(--accent-color);\n}\n\n/* ── Chat area ── */\n.chatWrap {\n  min-height: 0;\n  flex: 1;\n}\n\n/* ── Admin menu (fixed top-right) ── */\n.adminMenu {\n  position: fixed;\n  right: 12px;\n  top: 12px;\n  z-index: 30;\n}\n\n.adminNav {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  padding: 6px 10px;\n  border-radius: 6px;\n  border: 1px solid var(--border-color);\n  background: var(--surface-bg-2);\n  color: var(--accent-color);\n  font-size: 12px;\n  letter-spacing: 0.04em;\n}\n\n.adminIcon {\n  width: 14px;\n  height: 14px;\n  display: inline-flex;\n}\n\n.adminIcon svg {\n  width: 14px;\n  height: 14px;\n  fill: currentColor;\n}\n\n.caret {\n  color: var(--text-muted);\n  font-size: 10px;\n}\n\n.adminNav:hover {\n  border-color: var(--accent-color);\n  color: #ffffff;\n}\n\n.dropdown {\n  position: fixed;\n  right: 12px;\n  top: 44px;\n  min-width: 140px;\n  padding: 4px;\n  border-radius: 6px;\n  border: 1px solid var(--border-color);\n  background: var(--surface-bg-2);\n  z-index: 31;\n}\n\n.dropdownItem {\n  display: block;\n  padding: 7px 8px;\n  border-radius: 4px;\n  color: var(--text-color);\n  font-size: 12px;\n}\n\n.dropdownItem:hover {\n  background: var(--surface-bg);\n  color: var(--accent-color);\n}\n\n/* ── Mobile ── */\n@media (max-width: 768px) {\n  .page { padding: 8px; }\n  .centerPanel { height: calc(100vh - 16px); }\n  .titleWrap { padding: 10px 12px 10px; }\n  .title { font-size: 16px; padding: 0 90px 0 0; text-align: left; }\n  .motto { text-align: left; font-size: 11px; }\n  .industryBar { justify-content: flex-start; padding-top: 8px; }\n  .industryTab { padding: 4px 10px; font-size: 11px; }\n  .newSessionBtn { padding: 4px 10px; font-size: 11px; }\n  .adminMenu { right: 8px; top: 8px; }\n  .adminNav { padding: 5px 8px; font-size: 11px; }\n  .dropdown { right: 8px; top: 38px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `BiTsNxnj6nrd9bDgC6lA`,
	"centerPanel": `CgXUX7NDujQShZMK5vcp`,
	"titleWrap": `C4aDRQQUDNDPkGLjlSlQ`,
	"subtitle": `w_MEFWG8BBFST5LPqcxa`,
	"title": `CVDpMafseO9CpCz5hONg`,
	"motto": `y61vn5SfFjnkb6W3dbHm`,
	"industryBar": `iFyA4jcD63p09vj0nGM6`,
	"industryTabs": `tn69s3Xq7HuLYpYdLVx4`,
	"industryTab": `OoNymXT1YZ0bPv9uDsEg`,
	"industryTabActive": `wp54zMMFLtl1UnGz4xQJ`,
	"industryTabDot": `JXFJGVwXBSRu5vvFI18l`,
	"newSessionBtn": `pNZJP4sbuDev9pLViSYU`,
	"chatWrap": `yDAcrIfAnAuKPhhtNe0v`,
	"adminMenu": `f3WsfdlDkqKgcu9KWhAz`,
	"adminNav": `ARhJ81vxWhIrCb2FJ3W8`,
	"adminIcon": `EYWZmKlYHbe8lZm99BcR`,
	"caret": `Mqp7Ne5y56LGN3oR8A1Q`,
	"dropdown": `HuEvIUwGvfdtgQ9ylSvG`,
	"dropdownItem": `sHej7ppz0nJrKfRynUHX`
};
export default ___CSS_LOADER_EXPORT___;
